/*
 * Wijn.com zoekvenster op desktop: het typveld ligt precies over de vaste zoekbalk in de header
 * en de resultaten klappen daar direct onder open. Dit script meet bij het openen de plek van
 * die balk en geeft die door als CSS-variabelen; de vormgeving staat in wijncom-zoeken.css.
 * Mobiel (en als de balk niet in beeld is) blijft het gewone zoekvenster.
 */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 750px)');

  // Op mobiel past de lange tekst van de vaste balk niet in het zoekveld: daar een kortere.
  const tekst = () => {
    const veld = document.querySelector('#search-modal input.search-input');
    if (!veld) return;
    if (!veld.dataset.wzLang) veld.dataset.wzLang = veld.placeholder;
    veld.placeholder = 'Waar ben je naar op zoek?';
  };

  // Laatste meting bij de klik. Het thema zet bij het openen de pagina vast (body position: fixed met
  // top -scrollY, assets/dialog.js); daarna staat de balk niet meer waar de klant hem zag. Was de pagina
  // gescrold, dan kwam het venster midden op het scherm (baas 31-10-2026). Bij een vastgezette pagina
  // gebruiken we daarom de meting van het moment van klikken.
  let laatst = null;

  const zet = () => {
    tekst();
    const dialoog = document.querySelector('#search-modal dialog');
    if (!dialoog) return;
    const vast = document.body.style.position === 'fixed';
    let r = null;
    if (vast && laatst && performance.now() - laatst.tijd < 2000) {
      r = laatst.r;
    } else {
      const balk = [...document.querySelectorAll('.header__column--center .search-modal__button')].find(
        (knop) => knop.offsetParent !== null
      );
      r = balk ? balk.getBoundingClientRect() : null;
      if (r && !vast) laatst = { r, tijd: performance.now() };
    }
    if (!DESKTOP.matches || !r || r.width === 0 || r.top < 0 || r.bottom > window.innerHeight) {
      dialoog.classList.remove('wz-onder-balk');
      return;
    }
    dialoog.style.setProperty('--wz-top', `${r.top}px`);
    dialoog.style.setProperty('--wz-left', `${r.left}px`);
    dialoog.style.setProperty('--wz-balk', `${r.width}px`);
    dialoog.style.setProperty('--wz-hoogte', `${r.height}px`);
    dialoog.classList.add('wz-onder-balk');
  };

  const volg = () => {
    tekst();
    DESKTOP.addEventListener('change', tekst);
    const dialoog = document.querySelector('#search-modal dialog');
    if (!dialoog) return;
    new MutationObserver(() => {
      if (dialoog.open) zet();
    }).observe(dialoog, { attributes: true, attributeFilter: ['open'] });
  };

  document.addEventListener(
    'click',
    (e) => {
      if (e.target.closest && e.target.closest('.search-modal__button')) zet();
    },
    true
  );
  window.addEventListener('resize', () => {
    if (document.querySelector('#search-modal dialog[open]')) {
      laatst = null;
      zet();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', volg);
  } else {
    volg();
  }
})();
